(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turnover-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('turnover-signup')) {
    // Official pinned distribution, loaded only when this section has an endpoint.
    let phoneAssets;
    const loadPhoneAssets = () => {
      if (!phoneAssets) {
        const base = 'https://cdn.jsdelivr.net/npm/intl-tel-input@29.5.3/dist/';
        const load = (tag, url) => new Promise((resolve, reject) => {
          const element = document.createElement(tag);
          const timer = setTimeout(() => fail(), 12000);
          const fail = () => { clearTimeout(timer); element.remove(); reject(new Error('Phone assets unavailable')); };
          element.onload = () => { clearTimeout(timer); resolve(); };
          element.onerror = fail;
          if (tag === 'link') { element.rel = 'stylesheet'; element.href = url; }
          else { element.src = url; element.async = true; }
          document.head.appendChild(element);
        });
        phoneAssets = Promise.all([
          load('link', `${base}css/intlTelInput.css`),
          load('script', `${base}js/intlTelInputWithUtils.min.js`)
        ]).catch((error) => { phoneAssets = null; throw error; });
      }
      return phoneAssets;
    };
    customElements.define('turnover-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('[data-launcher]');
        this.form = this.querySelector('form');
        this.formView = this.querySelector('[data-form-view]');
        this.successView = this.querySelector('[data-success-view]');
        this.status = this.querySelector('[role="status"]');
        this.phone = this.form.elements.phone;
        this.consent = this.form.elements.sms_consent;
        this.submit = this.form.querySelector('[type="submit"]');
        if (!this.dataset.endpoint || !this.dialog.showModal) return;
        this.phoneReady = loadPhoneAssets().then(async () => {
          if (options.signal.aborted) return false;
          this.iti = window.intlTelInput(this.phone, {
            initialCountry: 'us', separateDialCode: true,
            countrySelectorMode: 'AUTO', dropdownParent: this.dialog, fullscreenParent: this.dialog,
            strictMode: false, allowedNumberTypes: ['MOBILE', 'FIXED_LINE'],
            formatAsYouType: true
          });
          await this.iti.promise;
          return true;
        }).catch(() => false);
        this.launcher.hidden = false;
        this.launcher.addEventListener('click', () => {
          clearTimeout(this.successTimer);
          this.dialog.showModal();
        }, options);
        this.querySelector('[data-close]').addEventListener('click', () => {
          clearTimeout(this.successTimer);
          this.dialog.close();
        }, options);
        this.dialog.addEventListener('cancel', () => clearTimeout(this.successTimer), options);
        this.dialog.addEventListener('close', () => {
          clearTimeout(this.successTimer);
          try { localStorage.setItem('turnover-signup-dismissed', 'true'); } catch (_) {}
          this.launcher.focus();
        }, options);
        const syncConsent = () => {
          const present = Boolean(this.phone.value.trim());
          this.consent.closest('label').hidden = !present;
          this.consent.required = present;
          this.phone.setCustomValidity('');
        };
        this.phone.addEventListener('input', syncConsent, options);
        this.phone.addEventListener('countrychange', syncConsent, options);
        syncConsent();
        this.form.addEventListener('input', () => this.form.elements.email.setCustomValidity(''), options);
        this.form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const email = this.form.elements.email;
          if (!email.value.trim() && !this.phone.value.trim()) {
            email.setCustomValidity('Enter an email or phone number.');
            email.reportValidity();
            return;
          }
          if (this.submit.disabled) return;
          this.submit.disabled = true;
          this.status.textContent = 'Signing up…';
          try {
            let phone = '';
            if (this.phone.value.trim()) {
              if (!await this.phoneReady) throw new Error('Phone assets unavailable');
              if (!this.iti.isValidNumberPrecise()) {
                this.phone.setCustomValidity('Enter a valid phone number for the selected country.');
                this.phone.reportValidity();
                this.status.textContent = 'Enter a valid phone number for the selected country.';
                return;
              }
              syncConsent();
              if (!this.form.reportValidity()) return;
              phone = this.iti.getNumber();
            }
            const response = await fetch(this.dataset.endpoint, {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: this.controller.signal,
              body: JSON.stringify({ full_name: this.form.elements.full_name.value, email: email.value,
                phone, sms_consent: this.consent.checked,
                company: this.form.elements.company.value, source: window.location.href })
            });
            const result = await response.json();
            if (!response.ok || !result.ok) throw new Error(result.message || 'Please try again.');
            const failed = Object.entries(result.providers || {}).filter(([, success]) => !success).map(([provider]) => provider);
            this.status.textContent = failed.length
              ? `Thanks for signing up. Your ${failed.includes('laylo') ? 'SMS' : 'email'} signup could not be completed. Please try again for that channel.`
              : 'Thanks for signing up. Stay tuned for Turnover updates.';
            if (!failed.length) {
              this.form.reset();
              this.iti?.setNumber('');
              this.consent.required = false;
              this.consent.closest('label').hidden = true;
              this.status.textContent = '';
              this.formView.hidden = true;
              this.successView.hidden = false;
              this.dialog.setAttribute('aria-labelledby', this.successView.querySelector('h2').id);
              clearTimeout(this.successTimer);
              if (this.dialog.open) {
                this.successView.focus();
                this.successTimer = setTimeout(() => {
                  if (this.isConnected && this.dialog.open) this.dialog.close();
                }, 3000);
              }
            }
            try { localStorage.setItem('turnover-signup-dismissed', 'true'); } catch (_) {}
          } catch (error) {
            if (error.name !== 'AbortError') this.status.textContent = error.message === 'Phone assets unavailable'
              ? 'Phone signup is temporarily unavailable. Try again later or sign up with email only.'
              : 'Signup could not be completed. Please try again.';
          } finally {
            this.submit.disabled = false;
            if (this.isConnected && !this.formView.hidden) this.status.focus();
          }
        }, options);
        let dismissed = false;
        try { dismissed = localStorage.getItem('turnover-signup-dismissed') === 'true'; } catch (_) {}
        if (!dismissed && !Shopify.designMode) {
          this.timer = setTimeout(() => { if (!document.querySelector('dialog[open]')) this.dialog.showModal(); }, Number(this.dataset.delay) * 1000);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.successTimer);
        this.controller?.abort();
        this.iti?.destroy();
        this.iti = null;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
